// Tyler.API.MetaData.ModifierKey
export enum ModifierKey {
    Alt = 0,
    Shift = 1,
    Ctrl = 2,
    Meta = 3
}
